import styled from "styled-components";

const HeaderWrapper = styled.div`
header {
    max-height: 250px;
    background-color: #fff;
    color: #61676e;
    text-transform: uppercase;
  
    .wrapper {
      display: flex;
      align-items: center;
      height: 100%;
        padding:  0.75rem 0;
      .logo {
        padding: 0.15rem 0;
        width: auto;
        cursor: pointer;
        img {
          height: 40px;
          width: 100%;
        }
      }
  
      .title {
        padding: 0 1rem;
        font-size: 1.25rem;
        cursor: pointer;
      }
  
      .back-wrapper {
        height: 100%;
        margin: 0 0 0 auto;
        display: inline-flex;
        .back,
        .lang {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          color: #61676e;
          span {
            // padding-top: 4px;
          }
        }
        .back {
          padding-left: 1rem;
          font-weight: 700;
          text-decoration: none;
        }
        .lang {
        border-right: 2px solid #818b9b;
          padding: 0 1rem;
          margin: 0;
          font-size: 1rem;
          span {
            font-family: "GESS";
          }
        }
  
        img {
          margin-left: 0.5rem;
          height: 20px;
        }
      }
    }
  }
  
  @media only screen and (max-width: 768px) {
  }
  
  @media only screen and (max-width: 576px) {
    header {
      .container {
        padding: 0;
      }
      .wrapper {
        flex-direction: column;
        .logo {
          width: 100%;
          text-align: center;
          img {
            width: auto;
          }
        }
        .title {
          text-align: center;
          padding: 0.25rem;
        }
        .back-wrapper {
          margin: 0;
          width: 100%;
          justify-content: space-around;
          border-top: 1px solid #4c565c;
          .back,
          .lang {
            border: 0 !important;
            padding: 0.5rem 0;
            line-height: 1rem;
            span {
              padding-top: 2px;
            }
          }
          img {
            height: 25px;
          }
        }
      }
    }
  }
  
  header.ar {
     font-family: 'GESS', Verdana, Geneva, Tahoma, sans-serif;
      .wrapper{
        .back-wrapper {
          margin: 0 auto 0 0;
          .lang {
            border-right:0;
            border-left: 1px solid #4c565c;
            span{
              font-family: "lato";
            }
          }
          .back {
            padding-right: 1rem;
            padding-left: 0;
          }
          img {
            transform: rotate(180deg);
            margin: 0;
            margin-right: 0.5rem;
          }
        }
      }
  }
  @media only screen and (max-width: 576px) {
    header.ar{
      .back-wrapper {
        .lang {
          font-size: 0.85rem;
          img{
            height: 24px;
          }
        }
    }
  }

`;

export default HeaderWrapper;
